import type { HandLegacyActionName } from './legacyActionNames';
import { LEGACY_ACTION_TO_PRODUCT_EVENT } from './productEvents';

export interface UserActionEnvelope {
  date: string;
  time: string;
  version: string | undefined;
  env: string | undefined;
}

export const buildUserActionEnvelope = (
  envelope: UserActionEnvelope,
  properties: Record<string, unknown>,
): Record<string, unknown> => ({
  date: envelope.date,
  time: envelope.time,
  version: envelope.version ?? '',
  env: envelope.env ?? '',
  ...properties,
});

/**
 * Emits legacy `UserAction` always; when autocapture flag is on, dual-emits bucket-(b)
 * product events for mapped legacy action names.
 */
export const trackLegacyUserAction = (
  track: (eventType: string, eventProperties: Record<string, unknown>) => void,
  eventName: HandLegacyActionName,
  envelope: UserActionEnvelope,
  properties: Record<string, unknown>,
  amplitudeAutocaptureEnabled: boolean,
  /** When set and autocapture is on, bucket-(b) product event uses this payload (snake_case taxonomy). */
  productEventProperties?: Record<string, unknown>,
): void => {
  const payload = buildUserActionEnvelope(envelope, properties);
  track('UserAction', { action: eventName, ...payload });

  if (!amplitudeAutocaptureEnabled) {
    return;
  }

  const productEvent = LEGACY_ACTION_TO_PRODUCT_EVENT[eventName];
  if (!productEvent) {
    return;
  }

  const productPayload = buildUserActionEnvelope(
    envelope,
    productEventProperties ?? properties,
  );
  track(productEvent, productPayload);
};
